import { useEffect } from "react";
import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Leadership } from "@/components/site/Leadership";
import { Services } from "@/components/site/Services";
import { Process } from "@/components/site/Process";
import { Faq } from "@/components/site/Faq";
import { WorshipBand } from "@/components/site/WorshipBand";
import { Inquire, Footer } from "@/components/site/Contact";
import { trackVisit } from "@/lib/track";

export default function FullSite() {
  useLenis();
  useEffect(() => { trackVisit(); }, []);
  return (
    <div className="grain relative bg-rc-bg text-rc-ink" data-testid="full-site">
      <Nav />
      <main>
        <Hero />
        <About />
        <Leadership />
        <Services />
        <Process />
        <WorshipBand />
        <Faq />
        <Inquire />
      </main>
      <Footer />
    </div>
  );
}
